import type { ParentProps } from "solid-js"
import { useLanguage } from "@/runtime/i18n/language"

export function SessionRouteFrame(props: ParentProps<{ padded?: boolean }>) {
  return (
    <div
      class="relative flex size-full flex-col"
      classList={{ "px-2 pb-[var(--shell-bottom-inset,8px)] pt-[var(--shell-top-inset,8px)]": props.padded }}
    >
      {props.children}
    </div>
  )
}

export function SessionPanelFrame(props: ParentProps<{ raised?: boolean }>) {
  return (
    <div
      data-slot="session-panel-frame"
      class="relative flex min-h-0 flex-1 flex-col overflow-hidden bg-v2-background-bg-base"
    >
      {props.children}
    </div>
  )
}

export function SessionLoadingSkeleton() {
  const language = useLanguage()
  return (
    <div
      data-slot="session-loading-skeleton"
      class="flex min-h-0 flex-1 flex-col px-5 py-6"
      role="status"
      aria-label={language.t("common.loading")}
      aria-busy="true"
    >
      <div class="mx-auto flex w-full max-w-[1000px] flex-col gap-4" aria-hidden="true">
        <div class="h-4 w-28 rounded bg-v2-background-bg-layer-02 animate-pulse" />
        <div class="h-4 w-3/4 rounded bg-v2-background-bg-layer-02 animate-pulse" />
        <div class="h-4 w-1/2 rounded bg-v2-background-bg-layer-02 animate-pulse" />
      </div>
      <div class="mx-auto mt-auto flex w-full max-w-[1000px] flex-col gap-3" aria-hidden="true">
        <div class="h-4 w-32 rounded bg-v2-background-bg-layer-02 animate-pulse" />
        <div class="h-28 w-full rounded-2xl bg-v2-background-bg-layer-02 animate-pulse" />
      </div>
    </div>
  )
}
